<div fxLayout="row" fxLayoutAlign="center center" class="mb-20">
  <div fxLayout="column" fxFlex="80%"
    fxLayoutAlign="space-around stretch" fxLayoutGap="20px">
    <br />
    <br />
    <h1 name="hdw-header" class="mat-h1"><b i18n="@@tutor-resources">Tutor resources</b></h1>
    <div fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="5%">
      <div fxLayout.xs="column" fxLayout.sm="column" fxLayout="row wrap" fxFlex="100%" fxLayoutAlign="center" fxLayoutGap.xs="20px" fxLayoutGap.sm="20px">
        <mat-card fxFlex="93%" class="mat-elevation-z4 hdw-card">
          <mat-card-content fxFlex="100%" fxLayout="column" fxLayoutGap="20px" class="tutor-resources-card-content">
            <div>
              <p i18n="@@tutor-quick-start"><b>Tutor ‘Quick Start’ Guide</b> (Nov 2024)</p>
              <span><mat-icon class="icon-resource-link-quick-start">download</mat-icon> 
                <a class="resource-link-quick-start" *ngIf="siteLanguageCode == welshLangCode; else defaultStartGuide" href="../../../../assets/pdf/WEST 2 Tutor & Administrator Guide (Welsh).pdf" target="_blank">WEST 2 Canllaw i Diwtoriaid a Gweinyddwyr (Cymraeg).pdf</a>
                <ng-template #defaultStartGuide>
                  <a class="resource-link-quick-start" href="../../../../assets/pdf/WEST 2 Tutor & Administrator Guide (English).pdf" target="_blank">WEST 2 Tutor & Administrator Guide (English).pdf</a>
                </ng-template>
              </span>
            </div>

            <div>
              <p i18n="@@identifying-support"><b>Identifying and supporting learners with dyslexic tendencies - 2010 courses</b> (Sep 2015)</p>
              <span><mat-icon>download</mat-icon> 
              <a class="resource-link" href="../../../../assets/pdf/Identifying and supporting learners with dyslexic tendencies - 2010 courses_v1.0.2.cleaned.pdf" target="_blank">Identifying and supporting learners with dyslexic tendencies - 2010 courses_v1.0.2.pdf</a></span>
            </div>

            <div>
              <p i18n="@@identifying-support-2015"><b>Identifying and supporting learners with dyslexic tendencies - 2015 courses</b> (Jan 2016)</p>
              <span><mat-icon>download</mat-icon> 
                <a class="resource-link" *ngIf="siteLanguageCode == welshLangCode; else defaultDyslexic" href="../../../../assets/pdf/Cydnabod a chefnogi dysgwyr â thueddiadau dyslecsig - 2015 cyrsiau_v1.0.cleaned.pdf" target="_blank">Cydnabod a chefnogi dysgwyr â thueddiadau dyslecsig - 2015 cyrsiau_v1.0.pdf</a>
                <ng-template #defaultDyslexic>
                  <a class="resource-link" href="../../../../assets/pdf/Identifying and supporting learners with dyslexic tendencies - 2015 courses_v1.0.cleaned.pdf" target="_blank">Identifying and supporting learners with dyslexic tendencies - 2015 courses_v1.0.pdf</a>
                </ng-template>
              </span>
            </div>
            
            <div>
              <p><b i18n="@@transcripts">Transcripts</b></p>
              <p i18n="@@transcripts-1">
                For use with hearing impaired learners, we can supply transcripts of the Communication listening questions.
                We recommend these are signed for the learner, or read out for lip reading. Please contact Support (<a href="mailto:Servicedesk@tribalgroup.com">Servicedesk@tribalgroup.com</a>) who can provide the transcripts on request.
              </p>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div *ngIf="isLoggedIn && (userProfile$ | async)?.roleId == learnerRole" class="browser-note" name="browser-note-container">
      <app-browser-note></app-browser-note>
    </div>
  </div>
</div>
